import { BASE_URL, createHeaders } from '../utils';
import { CroppingTemplate, PresetCreate, PresetResponse, PresetUpdate } from '../types';

export async function getPresets() {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/presets`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function updatePreset(presetData: PresetUpdate) {

  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/presets`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(presetData),
  });

  if (!response.ok) {
    console.error('Failed to update preset:', {
      status: response.status,
      statusText: response.statusText,
      data: await response.text(),
    });
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}
